import styled from "styled-components"

const Main = styled.main`
  min-height: 100vh;
  overflow: hidden;
`

export default Main
